<div *ngIf="!fieldTemplate; else customTemplate" [id]="field.field + '_Item'" class="inputItem">
    <mat-form-field appearance="fill"
                    [color]="field.color" #item [style.z-index]="index">
        <mat-label [class]="field.field + '_Label'">{{ field.label | translate }}</mat-label>
        <ng-container *ngIf="!field.selectSearchData; else inputMatAutocomplete">
            <input autocomplete="off" matInput [id]="field.field" type="text" [formControl]="inputFormControl" [readonly]="field.readonly" [placeholder]="placeholder"
                   (focus)="focus.emit($event)" (focusin)="focusin.emit($event)" (focusout)="focusout.emit($event)" (blur)="blur.emit($event)">
        </ng-container>
        <ng-template #inputMatAutocomplete>
            <input autocomplete="off" matInput [matAutocomplete]="autoText" [id]="field.field" type="text" [formControl]="inputFormControl" [readonly]="field.readonly" [placeholder]="placeholder"
                   (focus)="focus.emit($event)" (focusin)="focusin.emit($event)" (focusout)="focusout.emit($event)" (blur)="blur.emit($event)">
            <mat-autocomplete #autoText="matAutocomplete" [id]="field.field + '_List'" class="info selectSearchData" [displayWith]="displayWith(field, inputFormControl)">
                <mat-option *ngFor="let option of field.selectSearchData?.selectData?.options | async" [value]="option" class="select-search-option"
                            (mouseup)="$event.preventDefault(); $event.stopImmediatePropagation(); selectAutocompleteValue(option)">
                    {{ field.selectSearchData?.selectData | matGenericInputLabel : option : true }}
                </mat-option>
            </mat-autocomplete>
        </ng-template>
        <div matSuffix class="matSuffix">
            <button *ngIf="field.withClearButton" type="button" tabindex="-1" mat-icon-button (click)="$event.stopPropagation(); inputFormControl.patchValue('')">
                <mat-icon>close</mat-icon>
            </button>
            <mat-generic-input-slot [control]="inputFormControl" [field]="field" [fieldAddonTemplates]="fieldAddonTemplates$ | async"></mat-generic-input-slot>
        </div>
        <mat-error *ngIf="!(field.selectSearchData?.selectData?.options | async)?.length">
            <mat-generic-input-hint type="error" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
        </mat-error>
        <mat-hint>
            <mat-generic-input-hint type="combined" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
        </mat-hint>
    </mat-form-field>
    <mat-progress-bar class="loading" color="warning" mode="indeterminate"
                      *ngIf="(inputFormControl?.statusChanges | async) === 'PENDING' || inputFormControl?.status === 'PENDING'"></mat-progress-bar>
</div>

<ng-template #customTemplate>
    <ng-container *ngTemplateOutlet="fieldTemplate.template, context: { $implicit: field, genericInput: this, formControl: inputFormControl, index: index }"></ng-container>
</ng-template>
